import { createReducer } from '../../lib/Utils'
import { GET_CONTENT_DISCOVERY_FULFILLED } from './actions'

const initialState = {
  contentDiscovery: {},
}

export default createReducer(initialState, {
  [GET_CONTENT_DISCOVERY_FULFILLED]: (state, action) => {
    const contentDiscovery = action.payload.response
    return { ...state, contentDiscovery }
  },
})
